let normalPlural = function normalPlural(count, one, some, many, none) {
    let lastNumber = count % 10;
    let lastNumbers = count % 100;

    if (lastNumber === 1 && lastNumbers !== 11) {
        return one;
    }

    if ((lastNumber > 1 && lastNumber < 5) && (lastNumbers < 10 || lastNumbers > 20)) {
        return some;
    }

    if (count === 0) {
        return none || many;
    }

    return many;
};

let shortPlural = function shortPlural(count, one, some, many, none) {
    if (count === 1) { return one }

    if (count === 0) { return none || some }

    return some;
};

module.exports = {
    be: {
        plural: normalPlural,
    },
    ru: {
        plural: normalPlural,
    },
    en: {
        plural: shortPlural,
    },
    kk: {
        plural: shortPlural,
    },
    tr: {
        plural: normalPlural,
    },
    tt: {
        plural: normalPlural,
    },
    ua: {
        plural: normalPlural,
    },
    uk: {
        plural: normalPlural,
    },
    hy: {
        plural: shortPlural,
    },
    az: {
        plural: shortPlural,
    },
    ka: {
        plural: shortPlural,
    },
    lv: {
        plural: shortPlural,
    },
    uz: {
        plural: shortPlural,
    },
    sr: {
        plural: normalPlural,
    },
    lt: {
        plural: normalPlural,
    },
    fi: {
        plural: normalPlural,
    },
    he: {
        plural: shortPlural,
    },
};

module.exports.shortPlural = shortPlural;
module.exports.normalPlural = normalPlural;
